module.exports = "/_next/static/images/bank-cimb-niaga-icon-1d802a00af219ed37b838938ae294b2d.svg";